/**
 * All scraped price/expense data is denominated in BGN (Bulgarian lev) - the source market's
 * currency. `BGN_TO_EUR_RATE` is the lev's fixed peg to the euro (also Bulgaria's official
 * euro-adoption conversion rate), used to convert for display without touching how any of the
 * domain math (percentages, tax formulas, fuel cost) is computed internally.
 */
export const BGN_TO_EUR_RATE = 1.95583;

export function bgnToEur(bgn: number): number {
  return bgn / BGN_TO_EUR_RATE;
}

/** Inverse of `bgnToEur` - for EUR-sourced inputs (e.g. scraped fuel prices) feeding into the BGN-internal expense math. */
export function eurToBgn(eur: number): number {
  return eur * BGN_TO_EUR_RATE;
}
